@import './theme/fonts.css';
@import './theme/tokens.css';

*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body,
#root {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

body {
  font-family: var(--avatar-font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--avatar-surface-canvas);
  color: var(--avatar-text-primary);
}

button,
textarea,
input {
  font-family: inherit;
}

button:focus-visible,
textarea:focus-visible {
  outline: 2px solid var(--avatar-focus-ring);
  outline-offset: 2px;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-thumb {
  background: var(--avatar-color-gray-300);
  border-radius: var(--avatar-radius-pill);
}

::-webkit-scrollbar-track {
  background: transparent;
}
